/* @flow */

import React from 'react';
import { Segment, Header, Divider } from 'semantic-ui-react';
import { connect } from 'react-redux';
import {
  getImageStrategy,
  getImage,
  getCatchImageStrategy,
  getCatchImage,
} from 'news/reducers/images';
import * as ImagesActions from 'news/actions/images';
import OctoResourceCard from 'shared/components/OctoResourceCard';

type Props = {
  imageStrategy?: ResourceStrategy,
  image?: CatalogResource,
  catchImageStrategy?: ResourceStrategy,
  catchImage?: CatalogResource,
  updateImage: (resource: CatalogResource) => void,
  updateCatchImage: (resource: CatalogResource) => void,
  deleteImage: () => void,
  deleteCatchImage: () => void,
};

const mapStateToProps = state => ({
  imageStrategy: getImageStrategy(state),
  image: getImage(state),
  catchImageStrategy: getCatchImageStrategy(state),
  catchImage: getCatchImage(state),
});

const ImagesCard = ({
  imageStrategy,
  image,
  catchImageStrategy,
  catchImage,
  updateImage,
  deleteImage,
  updateCatchImage,
  deleteCatchImage,
}: Props) => {
  if (imageStrategy) {
    return (
      <Segment attached>
        <Header textAlign="center">Image titre</Header>
        <OctoResourceCard
          strategy={imageStrategy}
          resource={image}
          onUpdated={updateImage}
          onDeleted={deleteImage}
        />
        <Divider />
        <Header textAlign="center">{`Image d'accroche`}</Header>
        <OctoResourceCard
          strategy={catchImageStrategy}
          resource={catchImage}
          onUpdated={updateCatchImage}
          onDeleted={deleteCatchImage}
        />
      </Segment>
    );
  }

  return null;
};

export default connect(mapStateToProps, {
  updateImage: ImagesActions.updateImage,
  updateCatchImage: ImagesActions.updateCatchImage,
  deleteImage: ImagesActions.deleteImage,
  deleteCatchImage: ImagesActions.deleteCatchImage,
})(ImagesCard);



// WEBPACK FOOTER //
// ./src/modules/news/components/ImagesCard.js